import React from 'react';
import {FiInstagram ,FiMail } from 'react-icons/fi';
import { FooterOverlay, Newsletter } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">kigali,RWANDA</p>
        <p className="p__opensans">+250 783 095 968</p>
        <p className="p__opensans">+250 781 908 314</p>
      </div>

      <div className="app__footer-links_logo">
        <img src={images.gericht} alt="footer_logo" />
        <p className="p__opensans">&quot;The best way to find yourself is to lose yourself in the service of others.&quot;</p>
        <img src={images.spoon} alt='spoon' className="spoon__img" style={{ marginTop: 15 }} />
        <div className="app__footer-links_icons">
          <a href="https://www.instagram.com/babu_charles_250/"><FiInstagram /></a>
          <a href="mailto:Babucharles10@gmail.com"><FiMail/></a>
          

        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">07:00 am - 17:00 am</p>
        <p className="p__opensans">Saturday-Sunday:</p>
        <p className="p__opensans">07:00 am - 12:00 pm</p>
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">MURUGO Cantine. All Rights reserved.</p>
    </div>

  </div>
);

export default Footer;
